import styled, { css } from 'styled-components';

type TLoading = {
  small?: boolean;
  alternative?: boolean;
  inline?: boolean;
};

const Loading = styled.div<TLoading>(
  ({ theme, small, alternative, inline }) => css`
    border: 4px solid transparent;

    ${alternative &&
    css`
      border: 4px solid ${theme.colors.warmGrey};
    `}

    border-radius: 50%;
    border-top: 4px solid ${theme.colors.main.primary};
    width: 50px;
    height: 50px;
    -webkit-animation: spin 1.25s linear infinite; /* Safari */
    animation: spin 1.25s linear infinite;

    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    ${inline &&
    css`
      display: inline-block;
      margin-left: 1em;
      width: 1em;
      height: 1em;
      border-width: 2px;
      -webkit-animation: spin 0.8s linear infinite; /* Safari */
      animation: spin 0.8s linear infinite;
    `}

    ${small &&
    css`
      -webkit-animation: spin 0.8s linear infinite; /* Safari */
      animation: spin 0.8s linear infinite;
      width: 20px;
      height: 20px;
    `}
  `
);

export { Loading };
